import { ToastOptions } from "react-toastify";

export const ToastConfig: ToastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: "colored",
    className: 'custom-toast',
};
